'use strict';

// Functions for external pages (those accessible without logging in).
(function (snapOnline, $) {
    // Ensure required nested namespaces are declared.
    snapOnline.ExternalPages = snapOnline.ExternalPages || {};

    // Enhances the login page by disabling duplicate submissions once the "Log in" button has been clicked.
    snapOnline.ExternalPages.onLoginFormSubmitted = function () {
        var form = $('#loginForm');
        form.validate();
        if (form.valid()) {
            form.find(':input').prop('readonly', true);
            form.find(':button').prop('disabled', true).addClass('loading');
            $('#loginFailedMessage').hide();
        }
    };

    snapOnline.ExternalPages.logonChangeUser = function () {
        $("#loginShowPassword").val("false");
        $("#loginHasPassword").val("false");
        $("#loginForm").submit();
    };

    snapOnline.ExternalPages.loginRemindPassword = function () {
        var form = $("#loginForm");
        form.attr('action', snapOnline.getResourceActionUrl('Account', 'Remind'));
        form.submit();
    };

    snapOnline.ExternalPages.remindChangeUser = function () {
        var form = $("#remindChangeForm");
        form.submit();
    };

    snapOnline.ExternalPages.togglePassword = function () {
        var button = $("#btnpwdmode");
        var passwordField = $("#LoginPasswordEdit");
        var pwd_input_mode = passwordField.attr("type");

        if (pwd_input_mode == "password") {
            passwordField.attr("type", "text");
            button.removeClass("icon-show");
            button.addClass("icon-hide");
        } else {
            passwordField.attr("type", "password");
            button.removeClass("icon-hide");
            button.addClass("icon-show");
        }
    };

    // Toggles the "display" CSS property of the specified element, depending upon the keyboard's Caps Lock state.
    snapOnline.ExternalPages.hideElementUnlessCapsLockOn = function (event, elementId) {
        if ((typeof event.getModifierState) !== 'undefined') {
            if (event.getModifierState('CapsLock')) {
                document.getElementById(elementId).style.display = 'initial';
            } else {
                document.getElementById(elementId).style.display = 'none';
            }
        }
    };

    snapOnline.ExternalPages.Recaptcha = function (responseid) {
        var url = snapOnline.getResourceActionUrl('Account', 'VerifyCaptcha');
        var params = {
            response: responseid,
            __RequestVerificationToken: snapOnline.getRequestVerificationToken()
        };
        jQuery.post(url, params)
            .done(function (response) {
                var captchaResponse = jQuery.parseJSON(response.Response);
                if (captchaResponse.success) {
                    $('#hfCaptcha').val(captchaResponse.success);
                    $('#rfvCaptcha').hide();
                } else {
                    $('#hfCaptcha').val('');
                    $('#rfvCaptcha').show();
                    var error = captchaResponse['error-codes'][0];
                    $('#rfvCaptcha').html('RECaptcha error. ' + error);
                }
            });
    };

    snapOnline.ExternalPages.toggleDeviceName = function () {
        var rememberCheckBox = $('#RememberBrowser');
        if (rememberCheckBox[0].checked) {
            $('#deviceDiv').removeClass('hidden');
        } else {
            $('#deviceDiv').addClass('hidden');
        }        
    };

    snapOnline.ExternalPages.saveCookieStatus = function () {
        $('#cookieBanner').toggle();
        localStorage.setItem('HideCookieBanner', 'true');
    };

    snapOnline.ExternalPages.Login = function () {
        var url = snapOnline.getResourceActionUrl('Account', 'Login');
        window.location = url;
        return false;
    };

    snapOnline.ExternalPages.LDAP = function () {
        var url = snapOnline.getResourceActionUrl('Account', 'LDAP');
        window.location = url;
        return false;
    };

}(window.SnapOnline = window.SnapOnline || {}, jQuery));
